import { Flex, customStyled, variant } from '@mafc/trolly';

export const PriceInUSD = customStyled(Flex)<{ style: any }>(
  ({ theme }) => ({
    fontSize: theme.fontSizes[0],
    fontWeight: theme.fontWeights[8],
    color: theme.colors.black,
    justifyContent: 'end',
  }),
  ({ theme }) =>
    variant({
      variants: {
        cartOrderSummary: {
          justifyContent: 'start',
        },
        checkoutOrderSummary: {
          marginTop: '-14px',
          marginBottom: theme.space[3],
        },
        viewDetailDrawer: {
          marginTop: '-12px',
          marginBottom: `${theme.space[2]}px`,
        },
      },
    })
);
